import Vue from 'vue';
import Main from './main.vue';

let DialogConstructor = Vue.extend(Main);
let component;

DialogConstructor.prototype.hide = function() {
  this.show = false;
};
DialogConstructor.prototype.update = function(options) {
  options = Object.assign({
    title: '提示',
    text: null,
    cancelText: '取消',
    confirmText: '确认',
    fn: null
  }, options);
  for(let key in options) {
    this[key] = options[key];
  }
  this.show = true;
};

const show = function(options) {
  options = options || {};
  if(component) {
    component.update(options);
  } else {
    component = new DialogConstructor({
      data: options
    }).$mount();
    document.body.appendChild(component.$el);
  }
};
const hide = function() {
  component && component.hide();
};

export default {
  show,
  hide
};

